import { render, staticRenderFns } from "./RequestLocation.vue?vue&type=template&id=0a018a8a"
import script from "./RequestLocation.vue?vue&type=script&lang=js"
export * from "./RequestLocation.vue?vue&type=script&lang=js"
import style0 from "./RequestLocation.vue?vue&type=style&index=0&id=0a018a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports